import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import TimeInput from 'src/components/Pickers/TimeInput';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    TimeInput: TimeInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['currency', 'hour'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      saving: false,
      value: null
    };
  },
  computed: {
    icon: function icon() {
      switch (this.type) {
        case 'currency':
          return 'far:coins';

        case 'hours':
          return 'far:clock';

        default:
          return 'far:folder-bookmark';
      }
    }
  }
};